var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseGridLayout',{attrs:{"size":"small"}},[_c('HighlightBulletList',{attrs:{"id":_vm.anchorName,"headline-text":_vm.headlineText,"headline-tag":_vm.headlineTag,"list-items":_vm.listItems,"semantic-headline":_vm.semanticHeadline}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }